import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { useActiveCanvas } from '../../../hooks';
import { Drawer } from '../drawer/drawer';
import { DrawerPositions } from '../drawer/drawer-types';
import { HeaderContent, FooterContent } from './fragments';
import { ScaleDrawerProps } from './scale-drawer-types';
import styles from './scale-drawer.module.scss';

export const ScaleDrawer = ({ isOpen, onApply, onCancel, onChangeCallback }: ScaleDrawerProps): React.ReactElement => {
  const [originalScaleValue, setOriginalScaleValue] = useState<number | undefined>();

  const canvas = useActiveCanvas();

  const { t } = useTranslation();

  useEffect(() => {
    const activeObject = canvas?.current?.getActiveObject();
    if (activeObject?.type === 'image') {
      setOriginalScaleValue(activeObject.scaleX);
    }
  }, []);

  const handleClose = () => {
    const activeObject = canvas?.current?.getActiveObject();
    if (activeObject?.type === 'image') {
      activeObject.set({
        scaleX: originalScaleValue,
        scaleY: originalScaleValue,
      });
      canvas?.current?.renderAll();
    }
    onCancel();
  };

  return (
    <Drawer
      showVeil={false}
      hideCloseButton={true}
      addClass={styles['scale-drawer']}
      drawerPosition={DrawerPositions.Bottom}
      onClose={handleClose}
      isOpen={isOpen}
      headerContent={<HeaderContent onChangeCallback={onChangeCallback} />}
      footerContent={<FooterContent onApply={onApply} onCancel={handleClose} />}
    >
      <Typography variant={TypographyVariants.SRT}>{t('scaleDrawer.scaleDrawer')}</Typography>
    </Drawer>
  );
};
